import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard, CCol, CFormInput, CFormLabel, CFormSwitch, CRow } from '@coreui/react'
import Editor from 'src/components/Editor/Editor'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import { updateStaticPages } from 'src/Redux/Actions/templateAction'
import { useDispatch } from 'react-redux'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { checkPermissions, raiseToast } from '../../utils/helper'
import { isEmpty } from 'lodash'

const FAQ = ({ data }) => {
  const dispatch = useDispatch()
  const [pageName, setPageName] = useState(data.title)
  const [visibleStatus, setVisibleStatus] = useState(data.visible)
  const [dynamicInputList, setDynamicInputList] = useState([{ question: '', answer: '' }])

  const { userSessionObj } = useContext(GlobalContext)

  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.WEBSITE.UPDATE,
  )

  useEffect(() => {
    setPageName(data.title)
    setVisibleStatus(data.visible)
    if (!isEmpty(data.content)) {
      setDynamicInputList(data.content)
    }
  }, [data])

  const handleSave = async () => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    let payload = {
      title: pageName,
      visible_on_website: visibleStatus,
      content: dynamicInputList,
    }

    const updateRes = await dispatch(updateStaticPages(payload, data.id))

    if (updateRes?.success) {
      dispatch({ type: 'REFRESH_DATA' })
      dispatchAlert('success', `Success`, `Updated Successfully!`, true)
      raiseToast('success', 'FAQ updated successfully')
    }
  }

  const addFields = () => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    setDynamicInputList([...dynamicInputList, { question: '', answer: '' }])
  }

  const removeFields = (i) => {
    if (!updateAllowed)
      return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
    let temp = [...dynamicInputList]
    temp.splice(i, 1)
    setDynamicInputList(temp)
  }

  const handleQuestionChange = (e, i) => {
    let tempQues = [...dynamicInputList]
    tempQues[i].question = e.target.value
    setDynamicInputList(tempQues)
  }

  const handleAnswerChange = (e, i) => {
    let tempAns = [...dynamicInputList]
    tempAns[i].answer = e
    setDynamicInputList(tempAns)
  }

  console.log('dynamicInputList', dynamicInputList)
  let displayFields = () => {
    return dynamicInputList.map((ele, index) => (
      <div key={index}>
        <CRow className={'mt-3 FAQ-editor-Row'}>
          <CCol>
            <CFormLabel className="h6">Question {index + 1}</CFormLabel>
            <div className="d-flex">
              <CFormInput value={ele.question} onChange={(e) => handleQuestionChange(e, index)} />
              {index ? (
                <CIcon
                  icon={cilTrash}
                  style={{ color: 'red', cursor: 'pointer' }}
                  size="xxl"
                  title="Remove Question"
                  className="mx-2"
                  onClick={() => removeFields(index)}
                />
              ) : null}
            </div>
          </CCol>
        </CRow>
        <CRow className="mt-3 FAQ-editor-Row">
          <Editor value={ele.answer} handleChange={(e) => handleAnswerChange(e, index)} />
        </CRow>
      </div>
    ))
  }
  return (
    <div>
      <CCard style={{ minHeight: '37rem' }}>
        <div className="mt-5 mx-5 h-100">
          <div className="d-flex justify-content-between">
            <CCol xs="6">
              <CFormInput
                className="w-75"
                size="sm"
                value={pageName}
                onChange={(e) => setPageName(e.target.value)}
              />
            </CCol>
            <CCol className="d-flex justify-content-center">
              <CFormSwitch
                label={visibleStatus ? 'Enabled on your website.' : 'Disabled on your website.'}
                checked={visibleStatus}
                valid={visibleStatus}
                onChange={(e) => setVisibleStatus(e.target.checked)}
                size="lg"
              />
            </CCol>
          </div>
          <div className="mt-2 d-flex align-items-center">
            <CCol className="FAQ-container">{displayFields()}</CCol>
            {/*<CCol xs="4" className="d-flex">*/}
            {/*  <CFormText className="px-5">{data.description}</CFormText>*/}
            {/*</CCol>*/}
          </div>
          <CRow className="mt-3">
            <CCol>
              <CButton
                color="info"
                className="text-white"
                onClick={addFields}
                disabled={!updateAllowed}
              >
                Add Question
              </CButton>
            </CCol>
          </CRow>
          <div className="d-flex mt-4 flex-row-reverse mb-3">
            <CButton
              color="info"
              className="text-white mx-5"
              onClick={handleSave}
              disabled={!updateAllowed}
            >
              Save
            </CButton>
          </div>
        </div>
      </CCard>
    </div>
  )
}

export default FAQ
